<app-loading-spinner *ngIf="isLoading" [inline]="1"></app-loading-spinner>
<nav class="subnav">
  <div class="prev">
  </div>
  <h2>All Entries</h2>
  <div class="next"></div>
</nav>

<div class="container container-inner" *ngIf="userData">
  <div class="row">
    <ng-container  *ngFor="let week of allWeeksData; let index = index;">
    <div class="col-12 col-md-6" *ngIf="week.length>0">
      <h4 class="text-center mt-4 mb-2">Week {{userWeek - index}}</h4>
      <div class="card bg-light">
        <div class="card-body">
          <table class="entries-table">
            <thead>
              <tr>
                <th></th>
                <th>Session</th>
                <th>Level</th>
                <th>Set 1</th>
                <th>Set 2</th>
                <th>Set 3</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let entry of week">
                <tr>
                  <td>
                    <span class="et-cell text-dark fw-bold"
                      ><span class="et-total">{{
                        entry.workout_date | customDate : "DD"
                      }}</span
                      ><span class="et-label">{{
                        entry.workout_date | customDate : "MMM"
                      }}</span>
                    </span>
                  </td>
                  <td>
                    <span class="et-cell"
                      ><span class="et-total">{{ entry.session }}</span
                      ><span class="et-label"></span></span
                    >
                  </td>
                  <td>
                    <span class="et-cell"
                      ><span class="et-total">{{ entry.level }}</span
                      ><span class="et-label"></span></span
                    >
                  </td>
                  <td>
                    <span class="et-cell"
                      ><span class="et-total">{{ entry.set1_reps }}</span
                      ><span class="et-label">Reps</span></span
                    >
                  </td>
                  <td>
                    <span class="et-cell"
                      ><span class="et-total">{{ entry.set2_reps }}</span
                      ><span class="et-label">Reps</span></span
                    >
                  </td>
                  <td>
                    <span class="et-cell"
                      ><span class="et-total">{{ entry.set3_reps }}</span
                      ><span class="et-label">Reps</span></span
                    >
                  </td>
                  
                  <td>
                    <span class="et-cell"
                      ><a
                        [routerLink]="[
                          '/activity',
                          'move',
                          'edit-entry',
                          entry.user_strength_workout_id
                        ]"
                      >
                        <span class="icon-wrap duo-primary-dark"
                          ><fa-icon
                            [icon]="['fad', 'circle-chevron-right']"
                          ></fa-icon></span></a
                    ></span>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
</ng-container>
  </div>
</div>
